import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import httpRequestHandler from '../utils/helpers/httpRequestHandler';
import { COGNITO_GROUPS, FUNDING_SOURCE } from '../utils/constants/enum.ts';
const UserContext = React.createContext({
    userData: null,
    uiSecret: null,
    userDetail: null,
    adminType: {
        superAdmin: false,
        financeAdmin: false,
        isUpskillOnlyUserLoggedIn: false,
    }
});

export const UserContextProvider = (props) => {
    const [userData, setUserData] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [uiSecret, setUiSecret] = useState(null);
    const [userDetail, setUserDetail] = useState(() => {
        const stored = sessionStorage.getItem('userDetail');
        return stored ? JSON.parse(stored) : null;
    });
    const [adminType, setAdminType] = useState({
        superAdmin: false,
        financeAdmin: false,
        isUpskillOnlyUserLoggedIn: false
    });

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(async (user) => {
                if (user) {
                    setIsLoggedIn(true);
                    setUserData(user);
                    const isFirstLogin = sessionStorage.getItem('justLoggedIn') === 'true';
                    if (isFirstLogin) sessionStorage.removeItem('justLoggedIn');

                    const [res1, userDetailRes] = await Promise.all([
                        httpRequestHandler('/getuisettings', 'get'),
                        isFirstLogin ? httpRequestHandler('/getuserdetail', 'post', { Email: user.username }) : Promise.resolve(null),
                    ]);

                    setUiSecret(res1);
                    if (isFirstLogin && userDetailRes) {
                        sessionStorage.setItem('userDetail', JSON.stringify(userDetailRes));
                        setUserDetail(userDetailRes);
                    }
                    const cognitoGroups = user?.signInUserSession?.accessToken?.payload['cognito:groups'] ?? [];
                    const upskillGroups = [FUNDING_SOURCE.UpSkill_OC_CalOptima, FUNDING_SOURCE.Upskill_OC_Department_of_Veteran_Affairs, FUNDING_SOURCE.Upskill_OC_OYACPP_EDD];
                    setAdminType({
                        superAdmin: cognitoGroups?.includes(COGNITO_GROUPS.SuperAdminGroup),
                        financeAdmin: cognitoGroups?.includes(COGNITO_GROUPS.FinanceGroup),
                        isUpskillOnlyUserLoggedIn : cognitoGroups?.length > 0 && cognitoGroups.every(group => upskillGroups.includes(group))
                    })
                }
            })
            .catch((e) => {
                console.log(e);
                setIsLoggedIn(false);
            }).finally(() => {
                setIsLoading(false)
            });
    }, []);
    const setUiSecretHandler = (uiSecret) => {
        setUiSecret(uiSecret);
    };
    const contextValue = {
        isLoggedIn,
        userData,
        adminType,
        uiSecret,
        userDetail,
        setUiSecretHandler
    };

    if (isLoading) {
        return
    }

    return <UserContext.Provider value={contextValue}>{props.children}</UserContext.Provider>;
};

export default UserContext;
